import { useState, useEffect } from 'react';

const useMinimumLoading = (actualLoading, minimumTime = 500) => {
  const [showLoading, setShowLoading] = useState(true);
  const [startTime] = useState(Date.now());

  useEffect(() => {
    if (!actualLoading) {
      const elapsed = Date.now() - startTime;
      const remaining = Math.max(0, minimumTime - elapsed);
      
      if (remaining > 0) {
        const timer = setTimeout(() => {
          setShowLoading(false);
        }, remaining);
        
        return () => clearTimeout(timer);
      } else {
        setShowLoading(false);
      }
    }
  }, [actualLoading, startTime, minimumTime]);

  return showLoading;
};

export default useMinimumLoading;
